import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend';

i18n
  .use(HttpBackend) // Load translations using HTTP
  .use(LanguageDetector) // Detect user language
  .use(initReactI18next) // Bind react-i18next to React
  .init({
    lng: 'he', // Default language
    fallbackLng: 'he', // Default language
    supportedLngs: ['en', 'he'], // Supported languages
    debug: true,
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json', // Path to translation files
    },
    detection: {
      order: ['querystring', 'cookie', 'localStorage', 'navigator', 'htmlTag'], // Detection order
      caches: ['cookie', 'localStorage'], // Save user preference
    },
    interpolation: {
      escapeValue: false, // React already escapes values
    },
  });

export default i18n;
